import index from './detail.vue'
import Vue from '../../comm.js'

new Vue({
  el:'#app',
  template:"<index/>",
  components:{index}
})



// WEBPACK FOOTER //
// ./src/pages/worker/detail.js